var lastScrollTop = 0;
var timer = null;
const revealTimeout = 500;
const stickyHeader = document.querySelector(".sticky-header-wrapper");
const stickyMobileHeader = document.querySelector("header.banner");

//function to check if we're far enough down the page to trigger the sticky header reveal/hide
const stickyNavTrigger = (offset, scrollTop) => {
    if (scrollTop > offset) {
        return true;
    }
    else {
        return false;
    }
}
// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
window.addEventListener("scroll", function(){
        var offset = parseInt(window.innerHeight / 2) || 300;
        var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if(stickyNavTrigger(offset, st)) {
            if (st > lastScrollTop){
                // downscroll code
                stickyHeader.classList.remove("stuck");
                stickyMobileHeader.classList.remove("stuck");
            } else {
                // upscroll code
                stickyHeader.classList.add("stuck");
                stickyMobileHeader.classList.add("stuck");
            }
        }
        else {
            stickyHeader.classList.remove("stuck");
            //stickyMobileHeader.classList.remove("stuck");
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        

        if(timer !== null) {
            clearTimeout(timer);        
        }
        timer = setTimeout(function() {
            // do something
            if(stickyNavTrigger(offset, st)) {
                stickyHeader.classList.add("stuck");
                stickyMobileHeader.classList.add("stuck");
            }
        }, revealTimeout);
}, false);
//Kyle Sheldon - fix sticky header on mobile
(function($) {
    $('#primaryNavigation').on('show.bs.collapse', function () {
        // do something…
        // if(!(document.body.pageYOffset < 37)){
            $("body").addClass('menu-showing');
        //}
    }).on('hidden.bs.collapse', function () {
        // do something…
        $("body").removeClass('menu-showing');
    })
})(jQuery);

// //adjust display for small viewports dynamically

// window.addEventListener('resize', function(event){
//     let viewportWidth = window.innerWidth;

//     if(viewportWidth <= 393){
//         document.getElementById("menu-item-922").getElementsByTagName("a")[0].innerHTML = "Req Info";
//     } else{
//         document.getElementById("menu-item-922").getElementsByTagName("a")[0].innerHTML = "Request Information";
//     }
// });